
<template>
  <Row class="PanelChart w-100b f-wrap" y="s" x="s">
    <Column v-for="(item, i) in renderData" :key="i" class="chartItem bg-white p-tb-30 position-r radius-8 m-b-18" :class="i % 2 ==0 ? 'm-r-18' : ''">
      <Row class="w-100b p-lr-30 f-wrap" x="sb">
        <div class="position-a w-3 h-18 left-0 top-36 bg-primary radius-2" />
        <Row class="title-sm bold  m-b-30" y="c">
          <span>{{ $t(item.title) }}</span>
          <el-popover
            v-if="item.popover"
            placement="top"
            popper-class="-m-"
            :width="200"
            trigger="hover"
            :content="item.popover"
          >
            <template #reference>
              <IconSvg class="c-info font-11 m-l-5 m-b-1 pointer" name="icon-a-zu13873" />
            </template>
          </el-popover>
        </Row>
        <Row class="f-wrap">
          <Row class="m-b-30 m-r-20">
            <Row class="position-r">
              <IconSvg class="position-a top-8 right-8 font-11 c-info z-10" name="icon-a-zu13960" />
              <el-date-picker
                v-model="item.time"
                class="w-210 f-size-210"
                size="small"
                type="daterange"
                :shortcuts="getShortcuts(item)"
                range-separator="-"
                :start-placeholder="$t('table.startTime')"
                :end-placeholder="$t('table.endTime')"
                :default-time="defaultTime"
                :disabled-date="disabledDate"
                :clearable="false"
              >
                <template #range-separator>
                  <IconSvg class="font-11 m-lr-10 c-placeholder" name="icon-a-lujing10057" />
                </template>
              </el-date-picker>
            </Row>

            <el-button class="w-48 m-l-10" type="primary" @click="() => onSearch(item)">{{ $t('table.query') }}</el-button>
          </Row>
          <Row class="m-b-30">

            <el-button class="p-lr-10 m-r-10" type="primary" :plain="isYesterday(item.time) ? false : true" @click="() => timeChange(item.id, yesterday())">{{ $t('home.yesterday') }}</el-button>
            <el-button
              v-if="!item.hideToday"
              class="w-48"
              type="primary"
              :plain="isToday(item.time) ? false : true"
              @click="() => timeChange(item.id, today())"
            >{{ $t('home.taday') }}</el-button>
          </Row>
        </Row>
      </Row>
      <Row class="w-100b p-lr-30 f-wrap">
        <Column v-for="(it) in item.keys" :key="it.key" class="m-r-94 m-b-10">
          <Row class="c-info label-sm m-b-2">
            <div class="w-8 h-8 m-r-5 radius-2" :style="{'background-color': it.color}" />
            <span>{{ it.label }}</span>
            <span v-if="it.unit1">({{ it.unit1 }})</span>
          </Row>
          <Row class=" label bold">
            <div class="w-8 h-8 m-r-5 radius-2" />
            <Num v-if="it.unit1 == 'USDT' || it.unit2 == 'USDT'">{{ +$f.toFixed(item.data.reduce((n,e) => Number(e[it.key]) + n, 0), 2) }}</Num>
            <span v-else>{{ +$f.toFixed(item.data.reduce((n,e) => Number(e[it.key]) + n, 0), 2) }}</span>
            <span v-if="it.unit2" class="m-l-2">{{ it.unit2 }}</span>
          </Row>
        </Column>
      </Row>
      <div :id="item.id" v-loading="item.loading" class="w-100b h-320" />
    </Column>
  </Row>
</template>

<script setup>
import * as echarts from 'echarts'
const configStore = useConfigStore()

const defaultTime = [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]

const getShortcuts = (item) => [
  {
    text: $t('form.datePickerCycle.day3'),
    value: () => {
      const [startDay, endDay] = setTimeRange('day', 2, false)
      const start = startDay.format()
      const end = endDay.set('hour', 23).set('minute', 59).set('second', 59).format()
      const value = [start, end]
      timeChange(item.id, value)
      return value
    },
  },
  {
    text: $t('form.datePickerCycle.day7'),
    value: () => {
      const [startDay, endDay] = setTimeRange('day', 6, false)
      const start = startDay.format()
      const end = endDay.set('hour', 23).set('minute', 59).set('second', 59).format()
      const value = [start, end]
      timeChange(item.id, value)
      return value
    },
  },
  {
    text: $t('form.datePickerCycle.month1'),
    value: () => {
      const [startDay, endDay] = setTimeRange('month', 1, false)
      const start = startDay.format()
      const end = endDay.set('hour', 23).set('minute', 59).set('second', 59).format()
      const value = [start, end]
      timeChange(item.id, value)
      return value
    },
  },
  {
    text: $t('form.datePickerCycle.month3'),
    value: () => {
      const [startDay, endDay] = setTimeRange('month', 3, false)
      const start = startDay.format()
      const end = endDay.set('hour', 23).set('minute', 59).set('second', 59).format()
      const value = [start, end]
      timeChange(item.id, value)
      return value
    },
  },
]

const renderData = $ref(
  [
    {
      id: randomString(),
      api: dataApi.panelCommission,
      loading: false,
      key: '1',
      title: 'home.rebateData',
      time: [dayjs().subtract(6, 'day').set('hour', 0).set('minute', 0).set('second', 0).format(), dayjs().set('hour', 23).set('minute', 59).set('second', 59).format()],
      t: '',
      data: [],
      keys: [
        { key: 'totalCommission', label: $t('home.totalCommissions'), color: $theme.primary, unit1: '', unit2: 'USDT', },
        { key: 'selfCommission', label: $t('home.formRebate'), color: $theme.warning, unit1: '', unit2: 'USDT', dontChart: true },
        { key: 'directlyCommission', label: $t('home.directRebate'), color: $theme.info, unit1: '', unit2: 'USDT', dontChart: true },
        { key: 'teamCommission', label: $t('home.teamRebate'), color: $theme.success, unit1: '', unit2: 'USDT', dontChart: true },
      ],
      popover: $t('home.title1'),
      hideToday: true
    },
    {
      id: randomString(),
      api: dataApi.panelNewRegister,
      loading: false,
      key: '2',
      title: 'home.addUserData',
      time: [dayjs().subtract(6, 'day').set('hour', 0).set('minute', 0).set('second', 0).format(), dayjs().set('hour', 23).set('minute', 59).set('second', 59).format()],
      t: '',
      data: [],
      keys: [
        { key: 'registeredCount', label: $t('home.addPerson'), color: $theme.primary, unit1: '', unit2: $t('home.person'), },
        { key: 'firstDepositCount', label: $t('home.firstDepositPerson'), color: $theme.warning, unit1: '', unit2: $t('home.person'), },
        { key: 'firstTradeCount', label: $t('home.firstTradePerson'), color: $theme.success, unit1: '', unit2: $t('home.person'), },
      ],
    },
    {
      id: randomString(),
      api: dataApi.panelUser,
      loading: false,
      key: '3',
      title: 'home.userData',
      time: [dayjs().subtract(6, 'day').set('hour', 0).set('minute', 0).set('second', 0).format(), dayjs().set('hour', 23).set('minute', 59).set('second', 59).format()],
      t: '',
      data: [],
      keys: [
        { key: 'depositCount', label: $t('home.depositUser'), color: $theme.primary, unit1: '', unit2: $t('home.person'), },
        { key: 'tradeCount', label: $t('home.tradeUser'), color: $theme.success, unit1: '', unit2: $t('home.person'), },
      ],
    },
    {
      id: randomString(),
      api: dataApi.panelTrade,
      loading: false,
      key: '4',
      title: 'home.tradeData',
      time: [dayjs().subtract(6, 'day').set('hour', 0).set('minute', 0).set('second', 0).format(), dayjs().set('hour', 23).set('minute', 59).set('second', 59).format()],
      t: '',
      data: [],
      keys: [
        { key: 'fee', label: $t('home.totalFee'), color: $theme.error, unit1: '', unit2: 'USDT', },
        { key: 'newFee', label: $t('home.addFee'), color: $theme.success, unit1: '', unit2: 'USDT', },
      ],
    },
    {
      id: randomString(),
      api: dataApi.panelDeposit,
      loading: false,
      key: '5',
      title: 'home.depositAndWithdrawData',
      time: [dayjs().subtract(6, 'day').set('hour', 0).set('minute', 0).set('second', 0).format(), dayjs().set('hour', 23).set('minute', 59).set('second', 59).format()],
      t: '',
      data: [],
      keys: [
        { key: 'depositAmount', label: $t('home.totalDeposit'), color: $theme.error, unit1: 'USDT', unit2: '', },
        { key: 'newDepositAmount', label: $t('home.addDeposit'), color: $theme.success, unit1: 'USDT', unit2: '', },
      ],
      popover: $t('home.title5')
    },
  ]
)

const getSeriesData = (data, { key, label, color, dontChart, unit2 }) => {
  return {
    name: label,
    type: 'line',
    symbolSize: 6,
    smooth: true,
    showSymbol: true,
    emphasis: {
      focus: 'series'
    },
    lineStyle: {
      width: 1,
    },
    itemStyle: { color: color, },
    axisLine: {
      show: true,
    },
    labelLine: {
      show: true,
    },
    areaStyle: {
      opacity: 1,
      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        {
          offset: 1,
          color: hexToRgba(color, 0),
        },
        {
          offset: 0,
          color: hexToRgba(color, 0.1),
        },
      ])
    },
    data: data.map(e => {
      return {
        value: e[key] ?? 0,
        // symbol: 'none',
        dataItem: e,
        label: label,
        unit2: unit2,
        color: color
      }
    })
  }
}

const getTooltipDom = ({ label, value, unit1, unit2, color }) => {
  const unit = unit1 || unit2
  const isNum = unit == 'USDT'
  return `
    <div class="Flex-box label-sm row f-sb f-y-center">
      <div class="Flex-box row f-sb f-y-center">
        <div class="radius-2 m-r-5" style="width: 8px; height: 8px; background-color: ${color};"></div>
        <div>${label ?? ''}</div>
      </div>
      <div>
        <span class="m-r-5">${isNum ? $f.numFormat(+$f.toFixed(value, 2)) ?? 0 : value ?? 0}</span>
        <span>${unit ?? ''}</span>
      </div>
    </div>
  `
}

const lineChart = async ({ data, keys, id, key }) => {
  const dom = document.getElementById(id)
  const chart = echarts.init(dom, {})
  const xAxisData = data.map(e => e.date)
  const seriesData = keys.filter(e => !e.dontChart).map(k => getSeriesData(data, k))
  chart.setOption({
    animation: true,
    animationDuration: 400,
    grid: {
      show: false,
      // left: '6%',
      // right: '8%',
      top: '20px',
      bottom: '10%',
    },
    tooltip: {
      trigger: 'axis',
      textStyle: {
        color: '#fff',
      },
      backgroundColor: hexToRgba('#16151A', 0.85),
      formatter: (param) => {
        param = param[0]
        const dataIndex = param.dataIndex
        const d = data[dataIndex]
        const tooltipDom = keys.map(e => getTooltipDom({ label: e.label, key: e.key, unit1: e.unit1, unit2: e.unit2, value: d[e.key], color: e.color }))
        return `
        <div class=Flex-box label-sm column f-y-start f-x-start style="min-width: 210px; ;">
          <div>${param.name}</div>
          ${tooltipDom.reduce((o, e) => o + e, '')}
          </div>
        `
      }
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      axisLabel: {
        rich: {
          label: {
            fontSize: 14,
            fontWeight: '500',
          },
        }
      },
      axisLine: { show: false, },
      axisTick: { show: false, },
      data: xAxisData.map((e, i) => {
        let align
        if (i == 0) {
          align = 'left'
        } else if (i == xAxisData.length - 1) {
          align = 'right'
        } else {
          align = 'center'
        }
        return {
          value: e,
          textStyle: {
            color: $theme.info,
          }
        }
      }),
    },
    yAxis: {
      show: true,
      type: 'value',
      axisLabel: {
        color: $theme.info,
      }
    },
    series: seriesData
  })
  nextTick(() => {
    chart.resize()
  })
}

const getData = async (item) => {
  const [startTime, endTime] = item.time
  const api = item.api
  // console.log('getData 时间', dayjs(startTime).format('YYYY-MM-DD HH:mm'), dayjs(endTime).format('YYYY-MM-DD HH:mm'))
  const body = {
    startTime: dayjs(startTime).valueOf(),
    endTime: dayjs(endTime).valueOf(),
  }

  try {
    item.loading = true
    const d = await api(body)
    return d
  } finally {
    nextTick(() => {
      item.loading = false
    })
  }
}

const disabledDate = (t) => {
  const time = dayjs(t).valueOf()
  const eTime = dayjs().add(0, 'day').valueOf()
  // console.log(a)

  return time > eTime
}

const isYesterday = ([start, end]) => {
  const s = dayjs().subtract(1, 'day').set('hour', 0).set('minute', 0).set('second', 0)
  const e = dayjs().subtract(1, 'day').set('hour', 23).set('minute', 59).set('second', 59)

  if (isEmpty(start) || isEmpty(end)) {
    return false
  }
  return dayjs(start).format('YYYY-MM-DD HH:mm') == s.format('YYYY-MM-DD HH:mm') && dayjs(end).format('YYYY-MM-DD HH:mm') == e.format('YYYY-MM-DD HH:mm')
}
const isToday = ([start, end]) => {
  const s = dayjs().set('hour', 0).set('minute', 0).set('second', 0)
  const e = dayjs().set('hour', 23).set('minute', 59).set('second', 59)

  if (isEmpty(start) || isEmpty(end)) {
    return false
  }
  return dayjs(start).format('YYYY-MM-DD HH:mm') == s.format('YYYY-MM-DD HH:mm') && dayjs(end).format('YYYY-MM-DD HH:mm') == e.format('YYYY-MM-DD HH:mm')
}

const yesterday = () => {
  const start = dayjs().subtract(1, 'day').set('hour', 0).set('minute', 0).set('second', 0)
  const end = dayjs().subtract(1, 'day').set('hour', 23).set('minute', 59).set('second', 59)

  return [start, end]
}

const today = () => {
  const start = dayjs().set('hour', 0).set('minute', 0).set('second', 0)
  const end = dayjs().set('hour', 23).set('minute', 59).set('second', 59)

  return [start, end]
}

const timeChange = async (id, time) => {
  const item = renderData.find(e => e.id == id)
  item.time = time
  item.data = await getData(item)
  lineChart(item)
}

const onSearch = async (item) => {
  item.data = await getData(item)
  lineChart(item)
}

// eventBus.on('onResize', () => {
//   console.log('onResize')
//   chart.resize()
// })

onBeforeMount(async () => {
})

onMounted(async () => {
  renderData.forEach(async (e) => {
    e.data = await getData(e)
    lineChart(e)
  })
})

watch(() => configStore.locale, (value) => {
  console.log('value', value)
  setTimeout(() => {
    renderData.forEach(async (e) => {
      e.data = await getData(e)
      lineChart(e)
    })
  }, 500)
})

</script>

<style lang="scss">
.PanelChart{
  // .el-range-separator{

  // }
  .chartItem{
    width: calc((calc(100vw - 230px - 16px - 16px - 18px)) / 2)  ;
    min-width: calc((calc(1200px - 230px - 16px - 16px - 18px)) / 2)  ;
    overflow: hidden;
  }
  .el-date-editor{
    justify-content: space-between;
  }
}
</style>
